<template>
  <QuadroPrincipal
    loading
    class="loading-container"
    :borderTop="borderTop"
    :titulo="titulo"
    :classe="classe"
  >
    <transition name="fadeAlerta">
      <div v-if="exibeAlerta" class="alerta-atualização">
        <div>
          <div>
            <i class="fa fa-exclamation-triangle alerta-icone"></i>
            <p>
              Nossa base de dados está em atualização.
            </p>
          </div>
          <div class="alerta-texto">
            <p>
              O resultado pode demorar alguns segundos.
            </p>
          </div>
        </div>
      </div>
    </transition>

    <div class="loading-corpo">
      <LoadingPadraoContainer :fraseLoading="fraseLoading" :classe="classe" :delay="delay" />
    </div>
  </QuadroPrincipal>
</template>

<script>
import QuadroPrincipal from "@/components/QuadroPrincipal/QuadroPrincipal.vue";
import LoadingPadraoContainer from "@/components/LoadingPadrao/LoadingPadraoContainer.vue";

import axios from "axios";

export default {
  name: "LoadingResultado",

  components: {
    QuadroPrincipal,
    LoadingPadraoContainer
  },

  props: {
    titulo: Object | Array,
    classe: String,
    borderTop: Boolean
  },

  data() {
    return {
      exibeAlerta: false,
      fraseLoading: [
        "Aguarde um momento",
        "Consultando o banco de dados",
        "Processando os resultados",
        "Mais um momento, por gentileza",
        "Calculando dados"
      ],
      delay: "7000"
    };
  },

  mounted() {
    this.getImpotacoes();
  },

  methods: {
    async getImpotacoes() {
      let response = await axios.get(
        "https://rte-importador.econeteditora.com.br/listarArquivo.php"
      );
      this.exibeAlerta = !!response.data.length;
    }
  }
};
</script>

<style lang="scss" scoped>
.quadro-principal {
  height: 210px;
}
.loading-container {
  position: relative;
  border-radius: 10px;
  z-index: 2;
}
.alerta-atualização {
  padding: 0 50px;
  position: absolute;
  top: 10px;
  width: 100%;
  display: flex;
  justify-content: center;
  text-align: center;
  color: var(--branco);
  p {
    font-family: "Roboto Condensed";
    font-size: 15px;
    margin: 0;
    margin-top: 5px;
  }
  .alerta-texto {
    position: relative;
    top: 85px;
  }
}
.alerta-icone {
  font-size: 20px;
}
.loading-corpo {
  position: relative;
  z-index: -1;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--branco);
  background-color: #5454548c;
  font-size: 40px;
}
.fadeAlerta-enter-active,
.fadeAlerta-leave-active {
  transition: opacity 1s 5s ease;
}
.fadeAlerta-enter,
.fadeAlerta-leave-to {
  opacity: 0;
}
</style>
